import pushid from 'pushid';
import cloneDeep from 'clone-deep';

export const Menu = {
    state: {
        menus: [
            {
                type: 'header',
                layout: {
                    types: [1, 2, 3, 4],
                    align: ['left', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 1,
                            2: 6,
                            3: 1,
                            4: 3
                        }[theme];
                    }
                }
            },
            {
                type: 'footer',
                layout: {
                    types: [1, 2],
                    align: []
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 1,
                            2: 6,
                            3: 1,
                            4: 3
                        }[theme];
                    }
                }
            }
        ]
    },
    mutations: {},
    getters: {
        getMenus(state, getters, rootState) {
            if (rootState.tecpage.user && rootState.tecpage.user.menus) {
                return rootState.tecpage.user.menus;
            }
            return null;
        },
        getMenuFromType(state, getters) {
            return (name) => {
                let menus = getters.getMenus;
                if (menus === null) {
                    return null;
                }
                let menu = Object.values(menus).find((i) => i.type === name);
                if (menu === undefined) {
                    return null;
                }
                return menu;
            };
        },
        getMenuById(state, getters) {
            return (id) => {
                let menus = getters.getMenus;
                if (menus === null) {
                    return null;
                }
                let menu = Object.values(menus).find((i) => i.id === id);
                if (menu === undefined) {
                    return null;
                }
                return menu;
            };
        },
        getMenuIdFromType(state, getters) {
            return (name) => {
                let menu = getters.getMenuFromType(name);
                if (menu !== null) {
                    return menu.id;
                }
                return null;
            };
        },
        getMenuDataByType(state) {
            return (type) => {
                return cloneDeep(state.menus).find((i) => i.type === type);
            };
        },
        getActiveMenuId(state, getters, rootState) {
            if (rootState.route.query.menu_id) {
                return rootState.route.query.menu_id;
            }
            return null;
        },
        getActiveMenu(state, getters, rootState) {
            if (getters.getActiveMenuId !== null) {
                let id = getters.getActiveMenuId;
                if (rootState.tecpage.user && rootState.tecpage.user.menus) {
                    return rootState.tecpage.user.menus[id];
                }
            }
            return null;
        },
        getActiveMenuLayoutTypes(state, getters) {
            let menu = getters.getActiveMenu;
            if (menu !== null) {
                return cloneDeep(state.menus).find((i) => i.type === menu.type).layout.types;
            }
            return null;
        },
        getActiveMenuLayoutAlign(state, getters) {
            let menu = getters.getActiveMenu;
            if (menu !== null) {
                return cloneDeep(state.menus).find((i) => i.type === menu.type).layout.align;
            }
            return null;
        },
        getActiveMenuAppearanceColors(state, getters) {
            let menu = getters.getActiveMenu;
            if (menu !== null) {
                let colors = cloneDeep(state.menus).find((i) => i.type === menu.type).appearance
                    .colors;
                let obj = {};
                colors.forEach((colors__value) => {
                    obj[colors__value] = 'Variante ' + colors__value;
                });
                return obj;
            }
            return null;
        },
        getActiveMenuType(state, getters) {
            if (getters.getActiveMenu) {
                return getters.getActiveMenu.type;
            }
            return null;
        },
        menuExists(state, getters, rootState) {
            return (id) => {
                return id in rootState.tecpage.user.menus;
            };
        },
        generateClassForMenu(state, getters) {
            return (id) => {
                let menu = getters.getMenuById(id),
                    classes = {};
                if (menu === null) {
                    return null;
                }
                classes['menu'] = true;
                classes['menu-' + menu.type] = true;
                if (getters.getActiveMenuId === id) {
                    classes['menu-active'] = true;
                }
                if (menu.appearance && menu.appearance.color) {
                    classes['menu--color-' + menu.appearance.color] = true;
                }
                if (menu.layout && menu.layout.align) {
                    classes['menu-' + menu.type + '--align-' + menu.layout.align] = true;
                }
                if (menu.layout && menu.layout.type) {
                    classes['menu-' + menu.type + '--layout-' + menu.layout.type] = true;
                }
                if (menu.layout && menu.layout.position) {
                    classes['menu-' + menu.type + '--position-' + menu.layout.position] = true;
                }
                return classes;
            };
        },
        getLayoutType(state, getters) {
            return (id) => {
                let menu = getters.getMenuById(id);
                if (menu === null) {
                    return null;
                }
                if (menu.layout && menu.layout.type) {
                    return menu.layout.type;
                }
                return null;
            };
        },
        getAllowedLogoHeightFromType(state, getters) {
            return (id) => {
                let menu = getters.getMenuById(id),
                    allowedHeight = 80;
                if (menu === null) {
                    return null;
                }
                if (menu.layout && [3, 4].includes(menu.layout.type)) {
                    allowedHeight = 130;
                }
                return allowedHeight;
            };
        },
        getMenuBackground(state, getters) {
            return (id) => {
                let menu = getters.getMenuById(id);
                if (menu === null) {
                    return null;
                }
                if (
                    'appearance' in menu &&
                    'background' in menu.appearance &&
                    'active' in menu.appearance.background &&
                    menu.appearance.background.active == '1' &&
                    'image' in menu.appearance.background &&
                    menu.appearance.background.image != ''
                ) {
                    return menu.appearance.background.image;
                }
                return null;
            };
        }
    },
    actions: {
        async createMenu(context, payload) {
            let menuData = context.getters.getMenuDataByType(payload.type),
                activeTheme = context.getters.getActiveTheme;

            let appearance = {};
            if ('appearance' in payload) {
                appearance = payload.appearance;
            } else {
                appearance = {
                    color: menuData.appearance.defaultColor(activeTheme)
                };
            }

            let newItem = {
                id: pushid(),
                type: payload.type,
                data: payload.data || {},
                layout: payload.layout || {},
                appearance: appearance
            };
            await context.dispatch('setProp', {
                source: 'tecpage.user.menus.' + newItem.id,
                value: newItem
            });
            return newItem.id;
        },
        async setColorAppearanceForMenus(context) {
            let menus = context.getters.getMenus,
                activeTheme = context.getters.getActiveTheme;
            for (let menus__value of Object.values(menus)) {
                let menuData = context.getters.getMenuDataByType(menus__value.type),
                    color = menuData.appearance.defaultColor(activeTheme);
                await context.dispatch('setProp', {
                    source: 'tecpage.user.menus.' + menus__value.id + '.appearance.color',
                    value: color
                });
            }
        }
    }
};
